export default "__VITE_ASSET__BzjDg6tD__"